import React from "react";
import { cn } from "@gettactic/helpers";

export interface WizardReviewTextProps {
  label: string;
  value?: string | null;
  className?: string;
}

export const WizardReviewText: React.FC<WizardReviewTextProps> = ({
  label,
  value,
  className
}) => {
  if (!value) return null;

  return (
    <div className={className}>
      <span className="text-sm text-neutral-500">{label}</span>
      <p className="mt-1 text-sm text-neutral-900">{value}</p>
    </div>
  );
};
